import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { IconChevronRight, IconChevronLeft } from './Icons';
import * as styles from './styles.scss';

const Pagination = ({
    total,
    pageSize = 20,
    currentPage = 'currentPage',
    isLoading,
}) => {
    const { search, pathname } = useLocation();
    const page = parseInt(new URLSearchParams(search).get(currentPage)) || 1;
    const totalPages = Math.ceil(total / pageSize);

    const linkToPage = (page) => {
        const queryParams = new URLSearchParams(search);

        queryParams.set(currentPage, page);

        return `${pathname}?${queryParams.toString()}`
    };

    return (
        <div className={styles.pagination}>
            <div className={styles.actions}>
                <Link
                    to={linkToPage(page - 1 >= 1 ? page - 1 : 1)}
                    { ...(isLoading ? { style: { pointerEvents: 'none' } } : {}) }
                    aria-label="Previous"
                >
                    <IconChevronLeft />
                </Link>
                {page !== 1 && <Link to={linkToPage(1)}>1</Link>}
                {page === totalPages && <span>...</span>}
                <span>{page}</span>
                {page === 1 && <span>...</span>}
                {page !== totalPages &&<Link to={linkToPage(totalPages)}>{totalPages|| page}</Link>}
                <Link
                    to={linkToPage(page + 1 <= totalPages ? page + 1 : totalPages)}
                    { ...(isLoading ? { style: { pointerEvents: 'none' } } : {}) }
                    aria-label="Next"
                >
                    <IconChevronRight />
                </Link>
            </div>
        </div>
    )
};

export default Pagination;
